module.exports = __webpack_public_path__ + "img/134.cb69fda1.jpg";